import { useMemo } from 'react'
import { isFinite } from 'lodash'
import { useUpdaterChainId } from '~/hooks'
import { useTokenlonV6NetworkConfig } from '~/state/dex/hooks'
import { isMainnetOrSepolia } from '~/utils/chain'

export const useGasLimitScale = () => {
  const chainId = useUpdaterChainId()
  const { estimateGasLimitScale } = useTokenlonV6NetworkConfig()

  const gasLimitScale = useMemo(() => {
    const scale =
      !isMainnetOrSepolia(chainId) &&
      estimateGasLimitScale &&
      isFinite(estimateGasLimitScale) &&
      estimateGasLimitScale > 1.1
        ? estimateGasLimitScale * 100
        : 120

    return BigInt(Math.round(scale))
  }, [chainId, estimateGasLimitScale])

  return gasLimitScale
}
